import * as React from 'react';

import * as styles from './SeoMarkedList.css';
import { SeoMarkedListItem } from './components/SeoMarkedListItem';
import { Section } from '../../../ListingMobile/components/Section';
import { IMarkedListItem } from '../../types/listingOffers';

interface ISeoMarkedListProps {
  items: IMarkedListItem[];
}

export const SeoMarkedList: React.FC<ISeoMarkedListProps> = ({ items }) => (
  <Section className={styles['container']}>
    {items.map((item, index) => {
      const id = `SeoMarkedListItem_${index}`;

      return <SeoMarkedListItem key={id} id={id} {...item} />;
    })}
  </Section>
);
